import axios from "axios";

// Base API configuration
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://deebug.dev";

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const AUTH_KEYS = [
  "authenticated",
  "userId",
  "session_token",
  "userName",
  "userEmail",
];

const getAuthItem = (key) => {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
};

const hydrateSessionStorage = () => {
  AUTH_KEYS.forEach((key) => {
    const localValue = localStorage.getItem(key);
    const sessionValue = sessionStorage.getItem(key);

    if (!sessionValue && localValue) {
      sessionStorage.setItem(key, localValue);
    }
  });
};

const clearAuthItems = () => {
  AUTH_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
};

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    hydrateSessionStorage();

    const token = getAuthItem("session_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hasActiveSession =
        getAuthItem("authenticated") === "true" ||
        Boolean(getAuthItem("session_token"));

      if (hasActiveSession) {
        clearAuthItems();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export { apiClient, API_BASE_URL };
